import axios from 'axios';

const baseURL = process.env.VUE_APP_BASEURL;

const service = axios.create({
  baseURL
});

export { service };
